import { hotEvents } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

const maxHot = hotEvents[0]?.hot || 1;

export default function HotRank() {
  return (
    <section id="hot" className="scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto grid max-w-content gap-10 px-4 md:px-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <SectionHeading
            eyebrow="本周热榜"
            title="此刻大家都在看什么"
            desc="热度来自真实检索与讨论量的综合估算，每小时滚动更新，靠前的瓜热度最高。"
          />
          <div className="rounded-2xl border border-accent-200 bg-accent-50 p-5">
            <div className="flex items-center gap-2 text-accent-900">
              <i className="ri-flashlight-fill text-lg" />
              <p className="font-heading text-lg font-bold">吃瓜小贴士</p>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-accent-900/80">
              同一事件往往有多种说法。认准时间线里的「首次爆料 → 公开回应 → 补充证据」三个节点，能帮你更快看清分歧到底出在哪。
            </p>
          </div>
          <a
            href="#latest"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-foreground-800"
          >
            前往最新收录
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <ol className="flex flex-col gap-2.5">
          {hotEvents.map((h, i) => {
            const pct = Math.round((h.hot / maxHot) * 100);
            const up = h.delta >= 0;
            return (
              <li key={h.title}>
                <a
                  href="#latest"
                  className="group flex items-center gap-4 rounded-2xl border border-transparent bg-background-100/60 px-4 py-3.5 transition hover:border-primary-200 hover:bg-background-100"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-heading text-sm font-black ${
                      i < 3 ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
                      <span className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                        {h.title}
                      </span>
                      <span className="whitespace-nowrap rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-800">
                        {h.cat}
                      </span>
                    </span>
                    <span className="mt-1.5 block h-1 w-full overflow-hidden rounded-full bg-secondary-100">
                      <span
                        className={`block h-full rounded-full ${i < 3 ? "bg-primary-400" : "bg-secondary-300"}`}
                        style={{ width: `${pct}%` }}
                      />
                    </span>
                  </span>
                  <span className="hidden shrink-0 flex-col items-end gap-1 sm:flex">
                    <span
                      className={`inline-flex items-center gap-0.5 text-xs font-semibold ${
                        up ? "text-primary-500" : "text-foreground-400"
                      }`}
                    >
                      <i className={`${up ? "ri-arrow-up-line" : "ri-arrow-down-line"}`} />
                      {Math.abs(h.delta)}
                    </span>
                    <span className="whitespace-nowrap text-[11px] text-foreground-400">{h.reads}</span>
                  </span>
                </a>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}